import React from 'react';

import ChatRoomCard from './ChatRoomCard';
import { IChatRoomCardProps } from './types';

const ChatRoomList: React.FC<IChatRoomCardProps> = ({ chatRooms = [], refetchChatRoomData }) => (
  <>
    {chatRooms.map((chatRoom) => (
      <ChatRoomCard refetchChatRoomData={refetchChatRoomData} chatRoom={chatRoom} key={chatRoom.id} />
    ))}
  </>
);

export default ChatRoomList;
